import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useGetPodcastSupportList(data = {}) {
  const { enabled = false, config = {}, queryKey = ['podcast-tickets'] } = data;
  const { params = {} } = config;
  const { privateFetch } = useContext(FetchContext);

  const getCategory = () => privateFetch.get('/v1/admin/podcast/support/list', { params });

  return useQuery(queryKey, getCategory, {
    enabled,
    keepPreviousData: true,
  });
}

export default useGetPodcastSupportList;
